import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=40b20b92&"
import script from "./AppointmentsList.vue?vue&type=script&lang=js&"
export * from "./AppointmentsList.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports